import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import store from './store'
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
import router from './router'

Vue.config.productionTip = false

new Vue({
  vuetify,
  store,
  VueSweetalert2,
  router,
  render: (h) => h(App)
}).$mount('#app')
